// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m["default"] || m;
};

exports.components = {
  "component---apollo-day-deck-mdx": function componentApolloDayDeckMdx() {
    return import("/vercel/workpath0/apollo-day/deck.mdx"
    /* webpackChunkName: "component---apollo-day-deck-mdx" */
    );
  }
};